$(document).ready(function(){

 // var prevScrollpos = window.pageYOffset;
 //  $(window).scroll(function() {
 //  var scroll = $(window).scrollTop();
 //      var show_buy_bar = $('#shopify-section-FT-lose-gain-weight-banner').offset().top + 2;
 //      var currentScrollPos = window.pageYOffset;
 //      if (scroll > show_buy_bar) {
 //        if (prevScrollpos > currentScrollPos) {
 //          $('.FooterMainWrapperWedojm').removeClass('active');
 //          $('body').removeClass('stickyActive');
 //        } else {
 //          $('.FooterMainWrapperWedojm').addClass('active');$('body').addClass('stickyActive');
 //        }
 //        prevScrollpos = currentScrollPos;
 //      }
 //  })

    
    $("[js-reviews-slick-int]").slick({
	autoplay: true,autoplaySpeed: 5000,pauseOnHover: true,
    nextArrow: '<button type="button" class="slick-next-btn">Next</button>',
    prevArrow: '<button type="button" class="slick-prev-btn">Prev</button>',
	responsive: [{breakpoint: 2880,settings:{slidesToShow: 3,slidesToScroll: 3,infinite: true,adaptiveHeight: true,arrows: true,dots: false}},
                 {breakpoint: 768,settings: {slidesToShow: 1,slidesToScroll: 1,infinite: true,adaptiveHeight: true,arrows: true, centerMode: true, centerPadding: '50px'}}]
    });

$('[hh-brief-testimonialSlider]').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows:true,
  dots:false
});

  $('[js-block-descriptiobvw]').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows:false,
  dots:false
});

  $('[js-productbriefexecution]').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode:true,
  arrows:false,
  dots:false
});
  
$('.ImageIconTextBlockWpMb').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows:false,
  dots:true
});  

$(window).on('resize load',function(){
  if($(window).width() <= 768){
    $('.press-logo-content').slick({
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick"
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: false,
            slidesToShow: 2,
            autoplay: true,
            autoplaySpeed: 1300
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            dots: false,
            slidesToShow: 2,
            autoplay: true,
            autoplaySpeed: 1300
          }
        }
      ]
    });  
  }
})

$(document).on('click','.LiEachCustomerWp', function(e){
  e.preventDefault();
  if( $(this).hasClass('active') ){}else{
    var finder = $(this).attr('checker');var previousFinder = $('.LiEachCustomerWp.active').attr('checker');$(this).addClass('active').siblings().removeClass('active');
    $('[finder="'+finder+'"]').addClass('active').siblings().removeClass('active');$('.CustomerMainAccountWrapperEx').removeClass('currentlyactive-'+previousFinder).addClass('currentlyactive-'+finder);
    $('body').removeClass('accOpenTabs');
    $('.mobileAttribution').removeClass('active');
    $('.CustomerMainWpLeftSt').removeClass('active');
  }
})

$(document).on('click','[passwordChangeFiled] span', function(s){
  s.preventDefault();
  var HtmlText = $(this).text();
  HtmlText == 'Change password' ? $(this).text('Edit password') : $(this).text('Change password')
  $(this).parents('.COntenInfoaccount').children('.account_edit_pass').toggleClass('active');
})

$(document).on('click','.mobileAttribution', function(s){
  s.preventDefault();
  $('body').toggleClass('accOpenTabs');
  $(this).toggleClass('active');
  $(this).parents('.CustomerInnerMnWpExTim').children('.CudtomerAccountDetailsMnWp').children('.CustomerMainWpLeftSt').toggleClass('active');
}) 
});